import React from "react";
import { Button } from "antd";
import { NoData } from "../../assets/images";

export default function NoEventComponent({
  handleButtonClick = () => {},
  accessLevel,
}) {
  return (
    <div className="error-page-container">
      <img src={NoData} alt="no event" />
      <p className="error-page-text">
        Oops! <br /> It seems there are no events here yet.{" "}
        {accessLevel === 1 ? "Click below to create the first event!" : ""}
      </p>
      {accessLevel === 1 && (
        <Button
          type="primary"
          onClick={() => handleButtonClick()}
          icon={<i className="fa-solid fa-plus"></i>}
        >
          Create Event
        </Button>
      )}
    </div>
  );
}
